/* Booking widget for JP Ford Coin and Currency.
   Talks to the CSP Appointments API (see data-api on the container).
   Flow: choose type -> (house calls: address check) -> pick a time ->
   tell us about the collection -> confirmation. */

(function () {
  var root = document.querySelector('[data-appt]');
  if (!root) return;

  var api = root.getAttribute('data-api').replace(/\/$/, '');
  var state = { type: null, date: null, time: null, address: null, miles: null };
  var idempotencyKey = newKey();

  function newKey() {
    var random = 'xxxxxxxxxxxxxxxx'.replace(/x/g, function () {
      return Math.floor(Math.random() * 16).toString(16);
    });
    return 'appt-' + Date.now().toString(16) + '-' + random;
  }

  function $(selector) {
    return root.querySelector(selector);
  }

  function showStep(name) {
    root.querySelectorAll('.appt__step').forEach(function (step) {
      step.classList.toggle('is-active', step.getAttribute('data-step') === name);
    });
    var heading = root.querySelector('.appt__step.is-active .appt__step-title');
    if (heading) heading.setAttribute('tabindex', '-1');
    if (heading) heading.focus({ preventScroll: true });
    root.scrollIntoView({ block: 'start' });
  }

  function message(target, text, kind) {
    var box = $(target);
    if (!box) return;
    if (!text) {
      box.hidden = true;
      box.textContent = '';
      return;
    }
    box.hidden = false;
    box.className = 'appt__msg appt__msg--' + (kind || 'ok');
    box.textContent = text;
  }

  function friendlyDate(iso) {
    var parts = iso.split('-');
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function friendlyTime(hhmm) {
    var bits = hhmm.split(':');
    var hour = Number(bits[0]);
    var suffix = hour >= 12 ? 'PM' : 'AM';
    var display = hour % 12 === 0 ? 12 : hour % 12;
    return display + ':' + bits[1] + ' ' + suffix;
  }

  // --- Step 1: appointment type -------------------------------------------
  root.querySelectorAll('[data-type]').forEach(function (card) {
    card.addEventListener('click', function () {
      state.type = card.getAttribute('data-type');
      state.date = null;
      state.time = null;
      root.querySelectorAll('[data-type]').forEach(function (other) {
        other.classList.toggle('is-selected', other === card);
      });
      if (state.type === 'housecall') {
        message('[data-address-msg]', '', 'ok');
        showStep('address');
      } else {
        state.address = null;
        loadAvailability();
        showStep('when');
      }
    });
  });

  // --- Step 2: house-call address / service area --------------------------
  var addressForm = $('[data-address-form]');
  if (addressForm) {
    addressForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var street = $('#appt-street').value.trim();
      var city = $('#appt-city').value.trim();
      var stateField = $('#appt-state').value.trim();
      var zip = $('#appt-zip').value.trim();
      if (!street || !city || !zip) {
        message('[data-address-msg]', 'Please fill in your street, city, and ZIP so we can plan the drive.', 'err');
        return;
      }
      var body = new FormData();
      body.append('street', street);
      body.append('city', city);
      body.append('state', stateField);
      body.append('zip', zip);
      message('[data-address-msg]', 'Checking your area…', 'ok');

      fetch(api + '/distance.php', { method: 'POST', body: body })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          state.address = { street: street, city: city, state: stateField, zip: zip };
          if (data.status === 'out_of_range') {
            state.miles = data.miles;
            message('[data-address-msg]',
              'You look to be about ' + data.miles + ' miles from the shop, and our regular house-call area reaches '
              + data.max_miles + ' miles. Please give us a call — we may still be able to help — or book an in-store visit instead.',
              'warn');
            return;
          }
          if (data.status === 'unavailable') {
            message('[data-address-msg]',
              'We could not confirm the distance automatically, so we will double-check it by hand. Please continue.',
              'warn');
          } else {
            state.miles = data.miles;
            message('[data-address-msg]',
              'You are about ' + data.miles + ' miles away — well inside our house-call area. Please pick a time.',
              'ok');
          }
          loadAvailability();
          showStep('when');
        })
        .catch(function () {
          state.address = { street: street, city: city, state: stateField, zip: zip };
          message('[data-address-msg]',
            'We could not check the distance just now, so we will confirm it by hand. Please continue.', 'warn');
          loadAvailability();
          showStep('when');
        });
    });
  }

  // --- Step 3: choose a day and time --------------------------------------
  function loadAvailability() {
    var daysBox = $('[data-days]');
    var timesBox = $('[data-times]');
    daysBox.innerHTML = '<p class="appt__loading">Loading available times…</p>';
    timesBox.innerHTML = '';
    message('[data-when-msg]', '', 'ok');
    $('[data-when-next]').disabled = true;

    fetch(api + '/availability.php?type=' + encodeURIComponent(state.type) + '&days=28')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error('unavailable');
        var days = Object.keys(data.days || {});
        if (!days.length) {
          daysBox.innerHTML = '';
          message('[data-when-msg]',
            'We do not have open times posted right now. Please give us a call and we will find a time that works.', 'warn');
          return;
        }
        daysBox.innerHTML = '';
        days.forEach(function (day) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'appt__chip';
          button.innerHTML = friendlyDate(day) + '<small>' + data.days[day].length + ' open</small>';
          button.addEventListener('click', function () {
            state.date = day;
            state.time = null;
            daysBox.querySelectorAll('.appt__chip').forEach(function (chip) {
              chip.classList.toggle('is-selected', chip === button);
            });
            renderTimes(data.days[day]);
          });
          daysBox.appendChild(button);
        });
      })
      .catch(function () {
        daysBox.innerHTML = '';
        message('[data-when-msg]',
          'We could not load available times just now. Please refresh, or call the shop and we will book you by phone.', 'err');
      });
  }

  function renderTimes(times) {
    var timesBox = $('[data-times]');
    timesBox.innerHTML = '';
    $('[data-when-next]').disabled = true;
    times.forEach(function (time) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'appt__chip';
      button.textContent = friendlyTime(time);
      button.addEventListener('click', function () {
        state.time = time;
        timesBox.querySelectorAll('.appt__chip').forEach(function (chip) {
          chip.classList.toggle('is-selected', chip === button);
        });
        $('[data-when-next]').disabled = false;
      });
      timesBox.appendChild(button);
    });
  }

  $('[data-when-next]').addEventListener('click', function () {
    if (!state.date || !state.time) return;
    $('[data-chosen]').textContent = friendlyDate(state.date) + ' at ' + friendlyTime(state.time);
    showStep('about');
  });

  // --- Step 4: about the collection, contact details, attachments ---------
  var fileInput = $('#appt-files');
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var count = fileInput.files.length;
      $('[data-file-count]').textContent = count
        ? count + (count === 1 ? ' file selected' : ' files selected')
        : '';
    });
  }

  var detailsForm = $('[data-details-form]');
  detailsForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var submit = $('[data-submit]');
    var name = $('#appt-name').value.trim();
    var email = $('#appt-email').value.trim();
    var phone = $('#appt-phone').value.trim();
    if (!name || !email || !phone) {
      message('[data-details-msg]', 'Please add your name, email, and phone so we can reach you.', 'err');
      return;
    }

    var body = new FormData();
    body.append('idempotency_key', idempotencyKey);
    body.append('type', state.type);
    body.append('slot_start', state.date + ' ' + state.time);
    body.append('name', name);
    body.append('email', email);
    body.append('phone', phone);
    body.append('website', $('#appt-website').value); // honeypot
    body.append('intent', (root.querySelector('input[name="intent"]:checked') || {}).value || '');
    body.append('collection_size', $('#appt-size').value);
    body.append('graded', (root.querySelector('input[name="graded"]:checked') || {}).value || '');
    body.append('highlights', $('#appt-highlights').value.trim());
    body.append('notes', $('#appt-notes').value.trim());

    var kinds = [];
    root.querySelectorAll('input[name="collection_types"]:checked').forEach(function (box) {
      kinds.push(box.value);
    });
    body.append('collection_types', kinds.join(', '));

    if (state.address) {
      body.append('street', state.address.street);
      body.append('city', state.address.city);
      body.append('state', state.address.state);
      body.append('zip', state.address.zip);
      // The drive was already worked out on the address step. Send it on,
      // or the shop gets "distance unchecked" on every house call and has
      // to look the address up by hand before deciding whether to go.
      if (state.miles !== null && state.miles !== undefined) {
        body.append('miles', state.miles);
      }
    }
    if (fileInput && fileInput.files.length) {
      for (var i = 0; i < fileInput.files.length; i++) {
        body.append('attachments[]', fileInput.files[i]);
      }
    }

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    message('[data-details-msg]', 'Sending your request…', 'ok');

    fetch(api + '/book.php', { method: 'POST', body: body })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        if (!data.ok) {
          if (data.error_code === 'slot_taken') {
            message('[data-details-msg]', data.message, 'warn');
            loadAvailability();
            showStep('when');
            return;
          }
          message('[data-details-msg]', data.message || 'Something went wrong. Please try again or call the shop.', 'err');
          return;
        }
        message('[data-details-msg]', '', 'ok');
        var booking = data.booking;
        $('[data-done-title]').textContent = booking.status === 'confirmed'
          ? 'You are on the calendar'
          : 'We have your request';
        $('[data-done-body]').textContent = booking.status === 'confirmed'
          ? 'We will see you ' + booking.when + '. A confirmation and calendar invite are on the way to ' + email + '.'
          : 'We personally confirm every house call, so we will be in touch shortly about ' + booking.when
            + '. A copy of your request is on the way to ' + email + '.';
        idempotencyKey = newKey();
        showStep('done');
      })
      .catch(function () {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        message('[data-details-msg]',
          'We could not send that just now. Please try again, or call the shop and we will take care of it.', 'err');
      });
  });

  // --- Back links ---------------------------------------------------------
  root.querySelectorAll('[data-back]').forEach(function (link) {
    link.addEventListener('click', function () {
      showStep(link.getAttribute('data-back'));
    });
  });

  $('[data-restart]').addEventListener('click', function () {
    window.location.reload();
  });
})();
